import React from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import { BannerInner, BannerWrapper } from './FraudReview.styles';

interface Props {
  canManageFlag: boolean;
  onRemoveFlag: () => void;
  onConfirmFraud: () => void;
}

const FraudReviewBanner: React.FC<Props> = ({ canManageFlag, onRemoveFlag, onConfirmFraud }) => (
  <BannerWrapper
    background="warningBorder"
    pad={{ horizontal: '40px', vertical: 'spacing16' }}
    data-testid="fraud-review_banner"
  >
    <BannerInner>
      <Box flex={{ grow: 1, shrink: 1 }}>
        <Text size="medium" color="textBody">
          <Text size="medium" weight="bold" color="textBody">
            Payments on hold:{' '}
          </Text>
          The employee may continue to submit claims, but payments will not be sent until the
          account is reviewed.
        </Text>
      </Box>

      {canManageFlag && (
        <Box direction="row" gap="spacing12" flex={{ shrink: 0 }}>
          <AppButton
            buttonType="secondary"
            width="160px"
            testId="fraud-review_banner_remove-flag"
            onClick={onRemoveFlag}
          >
            Remove Flag
          </AppButton>
          <AppButton
            color="red"
            width="160px"
            testId="fraud-review_banner_confirm-fraud"
            onClick={onConfirmFraud}
          >
            Confirm Fraud
          </AppButton>
        </Box>
      )}
    </BannerInner>
  </BannerWrapper>
);

export default FraudReviewBanner;
